import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	gap: var(--margin-4);

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
	}
`;

export const DynamicListWrapper = styled.div`
	width: 80%;
`;

export const ChartCard = styled(Card)`
	align-self: flex-start;
	position: sticky;
	top: var(--margin-4);
`;
